import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { Button } from 'antd';

const StyledButtonContainer = styled.div`
  margin-top: 16px;
  margin-bottom: 24px;
`;

const ActionFooter = ({
  isMobile,
  disabled,
  primaryLabel,
  primaryAction,
  secondaryLabel,
  secondaryAction,
}) => {
  return (
    <StyledButtonContainer>
      <Button
        style={{ marginRight: '8px' }}
        type="primary"
        size={isMobile && 'large'}
        disabled={disabled}
        onClick={primaryAction}
      >
        {primaryLabel}
      </Button>
      <Button onClick={secondaryAction} size={isMobile && 'large'}>
        {secondaryLabel}
      </Button>
    </StyledButtonContainer>
  );
};

ActionFooter.propTypes = {
  isMobile: PropTypes.bool,
  disabled: PropTypes.bool,
  primaryLabel: PropTypes.string,
  primaryAction: PropTypes.func,
  secondaryLabel: PropTypes.string,
  secondaryAction: PropTypes.func,
};

export default ActionFooter;
